const exportEmojiArt = {

	/**
	 * The text to display on the copy button.
	 *
	 * @type {string}
	 */
	clipboardLinkText: '',


	/**
	 * The text to display on the copy button.
	 *
	 * @type {string}
	 */
	clipboardArtText: '',


	/**
	 * The clipboard reset timeout.
	 *
	 * @type {object|null}
	 */
	clipboardTimeoutArt: null,


	/**
	 * The clipboard reset timeout.
	 *
	 * @type {object|null}
	 */
	clipboardTimeoutLink: null,


	/**
	 * Init the export settings.
	 *
	 * @return {void}
	 */
	init: function() {

		const share_button = document.getElementById( 'share-emoji-art' );
		share_button.addEventListener( 'click', exportEmojiArt.showModal );

		const download_button = document.getElementById( 'export-image' );
		download_button.addEventListener( 'click', exportEmojiArt.exportImage );

		const clipboard_art_button = document.getElementById( 'export-clipboard-art' );
		clipboard_art_button.addEventListener( 'click', exportEmojiArt.copyArtToClipboard );
		exportEmojiArt.clipboardArtText = clipboard_art_button.innerHTML;

		const clipboard_link_button = document.getElementById( 'export-clipboard-link' );
		clipboard_link_button.addEventListener( 'click', exportEmojiArt.copyLinkToClipboard );
		exportEmojiArt.clipboardLinkText = clipboard_link_button.innerHTML;

		const twitter_button = document.getElementById( 'export-twitter' );
		twitter_button.addEventListener( 'click', exportEmojiArt.shareTwitter );

	},


	/**
	 * Display the sharing modal.
	 *
	 * @param {object} e The click event that triggers the modal.
	 * @return {void}
	 */
	showModal: function( e ) {

		e.preventDefault();

		modal.show( '#modal-export' );

		setTimeout(
			() => {
				const shareContainer = document.getElementById( 'social-share' );
				shareContainer.innerHTML = shareModal.template( '', false );
			},
			100
		);

	},


	/**
	 * Copy the current emoji art to the clipboard.
	 *
	 * @param {object} e The click event that triggers the copy.
	 * @return {void}
	 */
	copyArtToClipboard: function() {

		const clipboard_button = document.getElementById( 'export-clipboard-art' );
		exportEmojiArt.clipboardText = clipboard_button.innerHTML;
		clipboard_button.innerHTML = '✅ Copied';

		clearTimeout( exportEmojiArt.clipboardTimeoutArt );

		exportEmojiArt.clipboardTimeoutArt = setTimeout(
			() => {
				clipboard_button.innerHTML = exportEmojiArt.clipboardArtText;
			},
			1250
		);

		// https://github.com/lgarron/clipboard-polyfill
		navigator.clipboard.writeText( exportEmojiArt.getEmojiArtAsText() + '#brushninja' );

	},


	/**
	 * Copy the current link to the clipboard.
	 *
	 * @param {object} e The click event that triggers the copy.
	 * @return {void}
	 */
	copyLinkToClipboard: function() {

		const clipboard_button = document.getElementById( 'export-clipboard-link' );
		exportEmojiArt.clipboardText = clipboard_button.innerHTML;
		clipboard_button.innerHTML = '✅ Copied';

		clearTimeout( exportEmojiArt.clipboardTimeoutLink );

		exportEmojiArt.clipboardTimeoutLink = setTimeout(
			() => {
				clipboard_button.innerHTML = exportEmojiArt.clipboardLinkText;
			},
			1250
		);

		// https://github.com/lgarron/clipboard-polyfill
		navigator.clipboard.writeText( window.location.href );

	},


	/**
	 * Get the emoji art as a text string with line breaks for easy sharing on
	 * social media/ clipboard.
	 *
	 * @return {string}
	 */
	getEmojiArtAsText: function() {

		const { width, height, art } = ninjaData.data;

		let text = '';
		for ( let y = 0; y < height; y++ ) {
			for ( let x = 0; x < width; x++ ) {
				text += art[ y ][ x ];
			}
			text += '\n';
		}

		return text;

	},


	/**
	 * Save the current emoji art as an image.
	 *
	 * @param {object} e The click event that triggers the save.
	 * @return {void}
	 */
	exportImage: function( e ) {

		e.preventDefault();

		const wrapper = document.querySelector( '#emoji-art-drawing .drawing-grid' );
		wrapper.style.lineHeight = 0;
		const canvasScale = Math.min( window.devicePixelRatio, 1.5 );
		// const canvasScale = 1;

		html2canvas(
			document.getElementById( 'emoji-art-drawing' ),
			{
				backgroundColor: null,
				scale: canvasScale,
			}
		).then(
			( canvas ) => {

				const src = canvas.toDataURL( 'image/png' );
				downloadLink( 'emoji-art.png', src );
				// wrapper.style.transform = '';
				wrapper.style.lineHeight = 1;

			}
		);

	},


	/**
	 * Share the current emoji art on Twitter.
	 *
	 * @param {object} e The click event that triggers the share.
	 * @return {void}
	 */
	shareTwitter: function( e ) {

		const text = exportEmojiArt.getEmojiArtAsText();

		const share_url = twitterShare( text );//, window.location.origin + window.location.pathname );

		window.open( share_url, '_blank' );

	},

};